import * as c from '../constants/ApprovalRequestHistoryConstants'

const initialState = {
  histories: {},
  fetching: false,
  fetched: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_PENDING:
      return { ...state, fetching: true, fetched: false, error: null }

    case c.FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        histories: {
          ...state.histories,
          [payload.id]: payload.approvalHistory
        }
      }

    case c.FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
